import React from "react";

const ResponsiveCardsDepartment = ({ data = [], onViewDepartment }) => {
  const renderCard = (item) => (
    <div key={item.id || item.key} className=" rounded-xl">
      <div className="bg-white border border-gray-200 rounded-xl p-2 shadow-sm">
        {/* 🔹 Header */}
        <div className="flex items-center justify-between mb-3">
          {/* Status */}
          {item.status !== undefined && (
            <div className="flex items-center gap-2 bg-blue-100 px-2 py-1 rounded-full flex-shrink-0 ml-2">
              <span className="text-[11px] text-blue-600 font-medium">
                {item.status ? "Active" : "Inactive"}
              </span>
              <div className="w-7 h-4 bg-gray-200 rounded-full relative">
                <div
                  className={`w-4 h-4 bg-white rounded-full absolute shadow ${
                    item.status ? "right-0" : "left-0"
                  }`}
                />
              </div>
            </div>
          )}
        </div>

        {/* 🔹 Info Grid */}
        <div className="grid grid-cols-2 gap-y-3 text-xs mb-3">
          <div>
            <p className="text-gray-400">Department</p>
            <p className="font-medium text-gray-800">
              {item.department || "-"}
            </p>
          </div>

          {/*    <div>
            <p className="text-gray-400">Subjects</p>
            <p className="font-medium text-gray-800">
              {item.subject_count || 0}
            </p>
          </div> */}

          <div>
            <p className="text-gray-400">No. of Teachers</p>
            <p className="font-medium text-gray-800">
              {item.noOfTeachers || 0}
            </p>
          </div>

          <div>
            <p className="text-gray-400">Department Courses</p>
            <p className="font-medium text-gray-800">
              {item.departmentCourses || 0}
            </p>
          </div>
        </div>

        {/* 🔹 Button */}
        <div className=" p-2 rounded-lg">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onViewDepartment(item);
            }}
            className="w-full  text-[#0068FF] bg-white text-sm font-medium py-2 rounded-lg hover:bg-gray-200 transition"
          >
            View Department
          </button>
        </div>
      </div>
    </div>
  );

  if (!data.length) {
    return (
      <div className="text-center text-gray-500 py-6 text-sm">
        No Department found
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 p-3">
      {data.map((item) => renderCard(item))}
    </div>
  );
};

export default ResponsiveCardsDepartment;